import { render, staticRenderFns } from "./PageTranslator.vue?vue&type=template&id=850bb16e&"
import script from "./PageTranslator.vue?vue&type=script&lang=js&"
export * from "./PageTranslator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports